// extracted by mini-css-extract-plugin
var _1 = "EmptyState-module__animateUploadProgressBarWidth--PK4s8";
var _2 = "EmptyState-module__animatedBackground--x2pet";
var _3 = "EmptyState-module__container--PcKzW";
var _4 = "EmptyState-module__left--FkPLg";
var _5 = "EmptyState-module__message--x2jiu";
var _6 = "EmptyState-module__noMargin--_YJh_";
var _7 = "EmptyState-module__right--hgDgp";
var _8 = "EmptyState-module__smallIcon--DWnFJ";
var _9 = "EmptyState-module__smallText--fGAbR";
var _a = "EmptyState-module__title--QTwuR";
var _b = "EmptyState-module__vertical--z_Pck";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "left", _5 as "message", _6 as "noMargin", _7 as "right", _8 as "smallIcon", _9 as "smallText", _a as "title", _b as "vertical" }
